import {Navigate, useLocation} from 'react-router-dom';
import {useSnackbar} from "notistack";
import {hasPermission} from "./AuthenticationUtil";
import {useAppSelector} from "../../Config/Hooks";
import {useAuthToken} from "../../Config/Hooks/useAuthToken";
import {CircularProgress, Box} from "@mui/material";

const ProtectedRoute = ({
                            hasAnyAuthorities,
                            redirectPath = '/',
                            children,
                        }) => {
    const location = useLocation();
    const { status: sessionStatus } = useAuthToken();
    const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorized = hasPermission(account?.authoritySet, hasAnyAuthorities);
    const { enqueueSnackbar } = useSnackbar();

    if (sessionStatus === 'resolving' || sessionStatus === 'initializing') {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: 8 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (sessionStatus === 'error') {
        return null;
    }

    if (isAuthorized) {
        return children;
    }

    if (isAuthenticated) {
        enqueueSnackbar("Você não está autorizado à acessar essa página", {
            variant: 'warning',
        });
        return null;
    }

    const redirectState = {
        from: {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
        },
    };

    return <Navigate to={redirectPath} replace state={redirectState} />;
};

export default ProtectedRoute;
